import { excelStreamFlow, excelBufferFlow } from 'ckd-diagnosis'

function fileToBuf(file, cb) {
  const fr = new FileReader()
  const filename = file.name

  fr.readAsArrayBuffer(file)
  fr.addEventListener(
    'loadend',
    (e) => {
      const buf = e.target.result
      cb && cb(buf, filename)
    },
    false
  )
}

// 节流时间戳
const throttle2 = function (fn, delay = 100) {
  let timer = null

  return function () {
    const context = this
    const args = arguments
    if (!timer) {
      timer = setTimeout(() => {
        fn.apply(context, args)
        clearTimeout(timer)
      }, delay)
    }
  }
}

export const analysisExcel = function (data, cb) {
  return new Promise((resolve, reject) => {
    // resolve(true)
    let buffData = ''
    fileToBuf(data.file, (buf, filename) => {
      buffData = buf
      excelBufferFlow(buffData, (percent, errorNum, rowNum) => {
        console.log(percent, errorNum, rowNum)
        cb && throttle2(cb)(percent, errorNum, rowNum)
      })
        .then((outBuffer) => {
          resolve(outBuffer)
        })
        .catch((e) => {
          reject(e)
          console.error(e)
        })
    })
  })
}
